(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class FooterMenu extends DetailsDisclosure {
      constructor() {
        super();
        this.reset(false);
        window.addEventListener('on:breakpoint-change', this.reset.bind(this));
      }

      reset() {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        const isConfirmNewsletter = !isLargeScreen &&
          (window.location.hash === "#footer-signup_form" && this.querySelector('#footer-signup_form') !== null);

        this.disclosure.open = isLargeScreen || isConfirmNewsletter;

        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
        } else {
          this.toggle.removeAttribute('tabindex');
        }
      }
    }

    customElements.define('footer-menu', FooterMenu);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mm-faq"] && !Shopify.designMode) return;
  try {
    
(() => {const reveal=()=>{const id=decodeURIComponent(location.hash.slice(1));const target=document.getElementById(id);if(target?.classList.contains('mm-faq-category'))target.open=true;};if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',reveal,{once:true});else reveal();window.addEventListener('hashchange',reveal);})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mm-home-reviews"] && !Shopify.designMode) return;
  try {
    
(() => {
const init = () => document.querySelectorAll('.mm-home-review-strip').forEach(() => {
  document.querySelectorAll('main product-card .slider').forEach((slider) => {
    slider.tabIndex = 0;
    const title = slider.closest('product-card').querySelector('.card__title');
    if (title) slider.setAttribute('aria-label', title.textContent.trim());
  });
});
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
else init();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mm-home-top"] && !Shopify.designMode) return;
  try {
    
(() => {
 const init=()=>document.querySelectorAll('[data-mm-top]').forEach(root=>{
  if(root.dataset.ready)return;root.dataset.ready='true';
  const track=root.querySelector('.mm-top-track');const btn=root.querySelector('[data-top-pause]');
  const reduced=matchMedia('(prefers-reduced-motion: reduce)');const mobile=matchMedia('(max-width:1399px)');
  let paused=reduced.matches,hovered=false;
  const update=()=>{btn.textContent=paused?'▶':'Ⅱ';btn.setAttribute('aria-pressed',String(paused));btn.setAttribute('aria-label',paused?'Reprendre le défilement':'Mettre le défilement en pause');};
  const move=d=>{const width=track.clientWidth;if(!width)return;const count=track.children.length;const current=Math.round(track.scrollLeft/width);track.scrollTo({left:((current+d+count)%count)*width,behavior:reduced.matches?'instant':'smooth'});};
  root.querySelector('[data-top-prev]').addEventListener('click',()=>{move(-1);});root.querySelector('[data-top-next]').addEventListener('click',()=>{move(1);});
  btn.addEventListener('click',()=>{paused=!paused;update();});
  root.addEventListener('pointerenter',()=>{hovered=true;});root.addEventListener('pointerleave',()=>{hovered=false;});
  track.addEventListener('touchstart',()=>{paused=true;update();},{passive:true});
  track.addEventListener('keydown',e=>{if(e.key==='ArrowRight'||e.key==='ArrowLeft'){e.preventDefault();paused=true;update();move(e.key==='ArrowRight'?1:-1);}});
  reduced.addEventListener('change',()=>{if(reduced.matches){paused=true;update();}});
  const timer=setInterval(()=>{if(!root.isConnected){clearInterval(timer);return;}if(mobile.matches&&!paused&&!hovered&&!document.hidden&&!root.contains(document.activeElement)&&root.getBoundingClientRect().bottom>0)move(1);},3000);update();
 });
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init,{once:true});else init();document.addEventListener('shopify:section:load',init);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mm-trustpilot-testimonials"] && !Shopify.designMode) return;
  try {
    
(() => {
 const init = () => document.querySelectorAll('[data-mm-carousel]').forEach(root => {
  if(root.dataset.ready) return;
  root.dataset.ready='true';
  const track=root.querySelector('.mm-review-track');
  const pause=root.querySelector('[data-pause]');
  const reduced=window.matchMedia('(prefers-reduced-motion: reduce)');
  let paused=root.dataset.autoplay!=='true'||reduced.matches;
  let hovered=false;
  const update=()=>{pause.textContent=paused?'Défiler':'Pause';pause.setAttribute('aria-pressed',String(paused));};
  const move=direction=>{
   const card=track.querySelector('.mm-review-slide');if(!card)return;
   const step=card.getBoundingClientRect().width+parseFloat(getComputedStyle(track).gap);
   const end=track.scrollWidth-track.clientWidth;
   let target=track.scrollLeft+direction*step;
   if(direction>0&&track.scrollLeft>=end-3)target=0;
   if(direction<0&&track.scrollLeft<=3)target=end;
   track.scrollTo({left:target,behavior:reduced.matches?'instant':'smooth'});
  };
  root.querySelector('[data-prev]').addEventListener('click',()=>{paused=true;update();move(-1);});
  root.querySelector('[data-next]').addEventListener('click',()=>{paused=true;update();move(1);});
  pause.addEventListener('click',()=>{paused=!paused;update();});
  root.addEventListener('pointerenter',()=>{hovered=true;});root.addEventListener('pointerleave',()=>{hovered=false;});
  track.addEventListener('touchstart',()=>{paused=true;update();},{passive:true});
  track.addEventListener('keydown',event=>{if(event.key==='ArrowRight'||event.key==='ArrowLeft'){event.preventDefault();paused=true;update();move(event.key==='ArrowRight'?1:-1);}});
  reduced.addEventListener('change',()=>{if(reduced.matches){paused=true;update();}});
  const timer=setInterval(()=>{if(!root.isConnected){clearInterval(timer);return;}const rect=root.getBoundingClientRect();if(!paused&&!hovered&&!document.hidden&&!root.contains(document.activeElement)&&rect.bottom>0&&rect.top<innerHeight)move(1);},6000);
  update();
 });
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init,{once:true});else init();
 document.addEventListener('shopify:section:load',init);
})();

  } catch(e) { console.error(e); }
})();
})();
